export type AccessLevel = 'NONE' | 'READ' | 'WRITE' | 'ADMIN'

export const ALL_LEVELS: readonly AccessLevel[] = ['NONE', 'READ', 'WRITE', 'ADMIN']

export const levelLabelKey = (level: AccessLevel): string => `Level_${level}`

export const LEVEL_CHIP: Record<AccessLevel, string> = {
  NONE: 'bg-muted text-muted-foreground border-transparent',
  READ: 'bg-blue-100 text-blue-800 border-blue-200',
  WRITE: 'bg-green-100 text-green-800 border-green-200',
  ADMIN: 'bg-amber-100 text-amber-900 border-amber-200',
}
